import React from 'react';
import Alert from '@mui/material/Alert';
export default function FormPopper({ formData, startTimeData, endTimeData, onUploadData, setLoadVisible, setPopper }) {
    /*-=-=-=-=-=-=-=-=-=-=-=-= Renders -=-=-=-=-=-=-=-=-=-=-=-=*/
    /* =+=+=+= renders the popup to confirm pto time =+=+=+= */
    const startDate = formData.startDate.toDateString().split(' ').slice(0, 4).join(' ');
    const startTime = startTimeData.find((time) => time.id === formData.startTime)?.display;

    const endDate = formData.endDate.toDateString().split(' ').slice(0, 4).join(' ');
    const endTime = endTimeData.find((time) => time.id === formData.endTime)?.display;

    const handleButtonClick = (isConfirmed) => {
        if (isConfirmed) {
            onUploadData();
        }
        setLoadVisible(false);
        setPopper(false);
    }

    return (
        <div id='popper'>
            <h4>Please Confirm Dates</h4>
            <Alert severity='warning'>You will not be able to edit request once sent</Alert>
            <div id='popper-times'>
                <div> <u><b>Start Date:</b></u> {` ${startDate} ${startTime}`}</div>
                <div> <u><b>End Date:</b></u> {` ${endDate} ${endTime}`}</div>
            </div>
            <div id='popper-buttons'>
                <button id='decline-button' onClick={() => handleButtonClick(false)}>Decline</button>
                <button id='confirm-button' onClick={() => handleButtonClick(true)}>Confirm</button>
            </div>
        </div>
    )

}